__webpack_require__.p = "/my-portfolio-vue/";